module.exports = {
  Dynamic: "Dynamic",
  LoginRequest: "8679601a-ecd3-a36b-83c4-3bc4a2e6b26f",
  LoginResponse: "e5cbddfa-18a0-e826-cf21-2f62249f8ca2",

  LogoutRequest: "174dd0f0-dc9e-a05c-87c7-dc3e46e59cbe",
  LogoutResponse: "ee1e0fc3-13b2-9110-6609-e8bc0511db08",

  GetDataByTimeRequest: "4e964f3d-491f-377e-15fe-c08083cec7e5",
  GetDataByTimeResponse: "adaa1935-6f4b-096c-0e91-3a1cec7f2e4f",

  StopDataUpdateRequest: "ee541150-c529-15b4-93df-47cae5d22e35",

  GetDataByCountRequest: "0e070386-cc1c-11e5-9956-625662870761",
  GetDataByCountResponse: "adaa1935-6f4b-096c-0e91-3a1cec7f2e4f",

  BatchJobDoneResponse: "6e48f926-6334-4b05-b1fd-71574f07627b",

  FindByNameOrDescription: "2184b3d7-ffda-a6b7-5892-33b16d3d6643",
  FindByNameOrDescriptionResponse: "d4a8016b-0156-6b72-88ad-e277df4567c1",

  FindByNameOrDescriptionSubscribedByUserRequest: "6ead3489-5e9a-47dc-b615-d73bf10b54b7",
  FindByNameOrDescriptionSubscribedByUserResponse: "395fba1a-6036-40ce-bfcb-9e8940e7a029",

  FindDataBankDatasetByNameOrDescriptionForUserOrOrgRequest: "9202d66b-992c-4baf-89e9-736b36193f07",
  FindDataBankDatasetByNameOrDescriptionForUserRequest: "2fa47c6f-2814-4df3-b736-d1bb1610ac00",

  GetDatasetById: "5351ec25-64b5-1abf-dc2c-94d6b1c94de7",
  GetDatasetByIdResponse: "298ba1d5-8187-d8df-8480-b78129d4b644",

  GetDatasetByIdWithUsersCreatedRequest: "e8c50b47-9cc6-4a07-b7f9-ceb7831b60bb",
  GetDatasetByIdWithUsersCreatedResponse: "582374ad-b009-4e03-9da1-b579371dba19",

  GetDataProfileById: "3605e158-7b53-8730-46cf-f108c7fe5a2d",
  GetDataProfileByIdResponse: "f171b684-68a0-33a5-a50c-79a43698f416",

  UpdateUIDashboard: "21c87001-f3d9-e731-02fb-40a7bdd3c884",
  UIDashboardUpdated: "cc8f84c3-57b4-4afe-0319-944c9b2e1245",
  UpdateUIDashboardRejected: "411079ad-e171-dcc4-ccb6-711a834a726b",

  CreateUIDashboard: "0abd6b09-21fc-8f0f-95e4-a52b90e6ea76",
  UIDashboardCreated: "d2e38021-c6c8-fc2c-4add-88b837af872b",
  CreateUIDashboardRejected: "0729361e-3289-4d55-5cc1-47794560d7fe",

  RemoveUIDashboard: "8217713f-5b5a-bbb4-0448-572d9c1d0c86",
  UIDashboardRemoved: "151fbbb1-48e6-dc64-6d67-8f1034ec6835",
  RemoveUIDashboardRejected: "98f07baa-e463-e7e6-fa40-654444c1a3cb",

  GetDashboards: "99cac521-5312-1933-2249-75247201cf3e",
  GetDashboardsResponse: "2dce09fb-7b4f-176d-c7bb-869cc5b0f83d",

  GetDashboardById: "7725e491-6055-4544-b0dd-d8628e782b72",
  GetDashboardByIdResponse: "e0468e82-8f2d-4f71-866d-bf28391f0345",

  UpdateUIDashboardState: "7ba4aca2-44a4-27c2-205e-4ecb2dd2d383",
  UIDashboardStateUpdated: "09d5ec3e-519a-07ed-52a9-fc110d634c58",
  UpdateUIDashboardStateRejected: "918b8c10-6a43-257e-4ebb-4c5d32fbe6c8",

  CreateUIDashboardState: "86d7b1d9-e257-25d2-68bd-9e17405e5fd3",
  UIDashboardStateCreated: "cb67f911-c896-2191-0f66-fa4f6bc9a2f9",
  CreateUIDashboardStateRejected: "4c5719f5-c2f4-5bfb-b199-5fcf77ad947e",

  GetDashboardStateById: "79cdf51b-c8dd-8a66-1bbd-3033c3ebb166",
  GetDashboardStateByIdResponse: "e08fc499-ef03-c46c-7f5b-65327d022b3b",

  UpdateUser: "30a4b59c-f46b-26da-216c-96e668dfd446",
  UserUpdated: "7a381a3d-38eb-3410-6cba-d866938415e2",
  UpdateUserRejected: "6cab4082-5d53-13f7-f614-6f2ac2ab7eae",

  CreateUser: "1cc58fa6-f069-0199-aeb3-611caf033652",
  UserCreated: "20262472-2cbb-83bb-15dd-62320708a4ee",
  CreateUserRejected: "29a13997-c7d9-0b04-2b85-52c838763229",

  RegisterUserRequest: "8272a0dc-98ff-1fb4-08b4-f53a562fb6e9",
  RegisterUserResponse: "d594c18b-4e65-73b6-9ce5-892f20112880",

  SearchUserByUserIdRequest: "d7fce5d4-3e54-0534-ad06-9e820713c7a0",
  SearchUserByUserIdResponse: "96f57b64-66e2-26f3-7bc5-f20dd41cf7c2",

  CreateDatasetRequest: "632b712c-4f5b-11e6-beb8-9e71128cae77",
  CreateDatasetResponse: "ed211028-5012-11e6-beb8-9e71128cae77",

  CreateDataProfile: "5b453581-889e-3140-5cc4-1a02bb7e19a2",
  DataProfileCreated: "a9db95ff-2be0-546f-85a3-338ddf0e63ab",
  CreateDataProfileRejected: "2eeb60ed-4766-2505-0cac-b7f2a1398756",

  RemoveUIDashboardState: "fb97cd81-2f5f-da7e-8704-644c709e5bf2",
  UIDashboardStateRemoved: "c715cfa7-156d-2547-3bed-1c681ee07ad2",
  RemoveUIDashboardStateRejected: "72f42478-8417-2e57-d422-6509ebf675c0",

  SubscribeDatasetRequest: "944cb199-3bd8-4f9a-f968-df8d889bfa21",
  SubscribeDatasetResponse: "e7f8d57c-e183-746c-3a8b-5d76cded7d7b",

  UnsubscribeDatasetRequest: "40c3ecb6-a481-a258-a8bd-b41d0b3073ae",
  UnsubscribeDatasetResponse: "cc72c413-b892-6d4a-4144-9bb4a546bb5b",

  CheckUserDatasetSubscriptionRequest: "e48b1e25-e347-c259-5bd7-dd38eb1ec796",
  CheckUserDatasetSubscriptionResponse: "4b67d0cf-11bb-def3-5dce-6ab836cbf9b1",

  GetDatasetSubscriptionsByUserIdRequest: "67ab7369-4c3b-973d-8dbb-0d63317a62fd",
  GetDatasetSubscriptionsByUserIdResponse: "bb7fb146-eadd-ad8f-0bef-a6365f1b43b9",

  GetAccessAuditInDaysByUser: "839bcab2-6c33-4fa8-916e-6d428c9cf07b",
  GetAccessAuditInDaysByUserResponse: "a2c58e31-a0e3-cbf2-ac23-a47ce69d95fe",

  GetAccessAuditInMonthsByUser: "69f0666d-062f-468a-aadb-1da4d9eedade",
  GetAccessAuditInMonthsByUserResponse: "ec11f1c3-5eee-30cb-a929-06ef38eb69cd",

  FindByNameOrDescriptionUnsubscribedByUserOrOrgRequest: "06b1a223-befb-4248-bcfe-a8187a3c61c6",
  FindByNameOrDescriptionUnsubscribedByUserOrOrgResponse: "88755b9a-f69e-4c06-8a3f-f65c689f5cbb",

  FindByNameOrDescriptionUnsubscribedByUserRequest: "14e847ee-748c-447d-b9a7-282f10c8d5f4",
  FindByNameOrDescriptionUnsubscribedByUserResponse: "e8deabdf-dbe7-4959-b56b-08e68469d681",

  FindDatasetLicenseRequest: "dc847f41-81a5-46f8-925f-ab359bf0cd95",

  GetAllDataProfilesRequest: "e238471c-864a-edb0-e487-427452668393",

  CreateDatasetLicense: "4c92e673-fbbb-47c8-9dd9-d1a1a68a319e",
  DatasetLicenseCreated: "2eaa73c7-696b-48ce-968c-767398b8be16",
  CreateDatasetLicenseRejected: "fdd274cd-1df6-490b-ba3b-d7e5dd1699af",

  CreateUserDatasetWidget: "cceeccaf-8de8-4118-9785-7f8fa9638c43",
  UpdateUserDatasetWidget: "e1f00f2e-1154-4343-9689-6cb4ea6b733a",
  FindDatasetWidgetsByUserRequest: "60aa0582-671a-4ba8-a95e-021e20fe8b57",
  FindDatasetWidgetByProfileRequest: "78f96b9b-9037-41ac-844d-52e479ef8b96",

  UpdateUserCredential: "e8837845-e076-24d6-987e-9d0bcfc98714",
  UserCredentialUpdated: "9e3df2d9-ef13-4147-cad5-a1e3f0463df7",
  UpdateUserCredentialRejected:"fb9b862d-8bbe-5147-779c-e78b52026acd",

  SubscribeRealTimeData: "30bf4945-1eb5-4584-9d41-5721aaee64cf",
  SubscribeRealTimeDataResponse: "e379edff-824c-4cb8-945f-b6f8f2c2b260",

  GetLatestData: "48ec2eaf-890f-43fa-a9de-5af32be6eea2",
  GetLatestDataResponse: "87ee547d-74f0-4d12-a2cf-5cb4da3d366b",

  GetDataForTimeRange: "60f9cd04-48f6-4d3d-83a7-9f8fe38df17f",
  GetDataForTimeRangeResponse: "aa07b44a-bb6c-404d-9d37-ab793a8b8665",

  GetDataAfterTime: "f0d9e43c-6131-41fe-ba70-138c6fd51393",
  GetDataAfterTimeResponse: "7915b81f-465c-4970-9eef-e453ab3e7766",

  GetDataBeforeTime: "41b173e9-83b3-4385-86a8-f114abd9a330",
  GetDataBeforeTimeResponse: "d35689ea-ce29-417f-a409-51ca21cdba88",

  NewPasswordResponse: "31a4e8e0-b64d-492b-a828-9eb7a692b208",

  DecryptLinkResponse: "ef90c5af-b84d-45c4-b9d1-3a4e06e70898",
  VerifyLinkResponse: "4839db4f-a14d-4fd8-a023-09c2a81de9ba",
  DecryptLinkRequest: "fc13ce76-f68d-4c72-a453-b9fc73642806",

  ForgotPasswordRequest: "980b0a54-f7e8-4064-b524-6dcbfaf6d36b",
  ForgotPasswordResponse: "43cb56f0-cdca-463e-a735-df82a6455e80",
  PasswordCheckChangeRequest: "983ba220-6a7c-4f53-82b3-c5c875300b18",
  PasswordCheckChangeResponse: "3c084cb4-5b69-4bd6-8a76-adcabb0896ae",

  GetDataByRecordLocation: "a7fe154f-eef4-4abe-8c12-257dec12c195",
  GetDataByRecordLocationResponse: "7fb59008-b872-4ef7-a365-3a1f956beabd",

  PublishDataRequest: "db5d67b9-f704-4b84-a5e6-24d7b4e814c0",
  PublishDataResponse: "523e1e6f-efad-42ce-9618-1d6d83802596",

  PublishData: "PublishData",

  TSCalculate: "edf2eff1-4012-4cc7-be4d-f36d707a1c0b",
  TSCalculateMinMaxAvgPSquare: "8593fad8-6cae-4227-b67a-6a4333b39e60",

  CountFilterByString: "75087d74-3146-4e3f-b196-fba6501615a6",
  WindowedDataRequest: "29b9dddf-b40d-4ddb-a58d-0e60623fdd34",

  TSCalculateFilterByString: "b9c76e1d-4007-4405-aea0-e61bcfa8a632",

  CanDealGoldReportRequest: "fed3a555-476b-42ae-aeb3-81edfe716c19",
  CanDealGoldReportResponse: "dfb6a7bf-374a-48ed-ab6d-d2383a1e42e",

  GetCurrentUserRequest: "febf0b2e-17de-11e8-b642-0ed5f89f718b",
  GetCurrentUserResponse: "02f0cc32-17df-11e8-b642-0ed5f89f718b",

  AuthorizationErrorResponse: "9664e688-e53c-11e5-9730-9a79f06e9478",

  GetAllApiKeyForCurrentUserRequest: "66db5b2c-7117-463f-a301-fe0fec98b63a",
  DeleteApiKeyRequest: "DeleteApiKeyRequest",
};


// WEBPACK FOOTER //
// ./src-client-lib/api/type-ids.js